<template>
    <div>
        <Breadcrumb class="breadcrumb">
            <BreadcrumbItem  class="click" to="/teachAdmin/appraisal/index">
                实训考核管理
            </BreadcrumbItem>
            <BreadcrumbItem >新增实训考核</BreadcrumbItem>
        </Breadcrumb>
        <div class="create-box">
            <div class="create-box-title">
                <h3>基本信息</h3>
            </div>
            <Form :model="createForm" ref="createForm" label-position="left" :label-width="110" :rules="ruleValidate">
                <Row>
                    <Col span="10">
                        <FormItem label="实训名称" class="form-item" prop="name">
                            <Input v-model="createForm.name" style="width: 200px" placeholder="请输入实训名称"></Input>
                        </FormItem>
                        <br />
                        <FormItem label="实训课程" class="form-item" prop="course_id">
                            <Select v-model="createForm.course_id" style="width:200px">
                                <Option :value="item.course_id" v-for="item in courseList" >{{item.course_name}}</Option>
                            </Select>
                        </FormItem>
                        <br />
                        <FormItem label="班级" prop="classes_ids">
                            <Select v-model="createForm.classes_ids" multiple style="width:400px">
                                <Option :value="item.class_id" v-for="item in train_class.body" >{{item.class_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="btn-box">
                <Button type="info" @click="save">保存</Button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex'
    export default {
        name:'create',
        data(){
            return {
                access_token:'',
                classList:[],
                createForm:{
                    name:'',
                    course_ids:0,
                    classes_ids:[],
                },
                ruleValidate:{
                    name:[
                        { required: true, message: '实训名称必填', trigger: 'blur' },
                    ],
                    classes_ids:[
                        { required: true, message: '班级必填', trigger: 'blur',type:'array' }
                    ],
                    course_id:[
                        { required: true, message: '课程必填', trigger: 'blur',type:'number' }
                    ],
                },
            }
        },
        methods:{
            ...mapActions({
                getTrainClass:'classAndStu/getTrainClass',
                saveAppraisal:'appraisal/saveAppraisal',
                getCourses:'courseManage/getCourses'

            }),
            // 保存
            save(){
                let _this = this;
                // 验证
                this.$refs['createForm'].validate((valid) => {
                    if (valid) {
                        this.saveAppraisal({
                            data:this.createForm,
                            callback:res=>{
                                // 不做跳转、下次将变为更新
                                _this.$Message.success('保存成功');

                                _this.$router.push({
                                    name: 'update',
                                    query: {id:res.id}
                                });
                            },
                            error:res=>{
                                if(res.status.code == 4040105){
                                    _this.train_class.body.forEach(item=>{
                                        if(item.class_id == res.body.class_id){
                                            _this.$Message.error("班级 ["+item.class_name+"] 已存在考核");
                                        }
                                    })
                                }else{
                                    _this.$Message.error(res.status.message);
                                }
                            }
                        });
                    } else {
                        _this.$Message.error('请填写完整内容');
                    }
                })
            },
            // 获取班级列表
            get_class_list(){
                this.getTrainClass({
                    page_size:1000,
                });
            }
        },
        computed:{
            ...mapState({
                courseList:state=>state.courseManage.all_courses,
                train_class:state=>state.classAndStu.train_class,
            })
        },
        mounted() {
            // 获取班级列表
            this.get_class_list();
            this.getCourses();
        }
    }
</script>
<style scoped lang="less">
    @import "../../style/index";
    @import "../../../../assets/style/exercises";
</style>
